/* eslint-disable no-unused-expressions */

import React, { Component } from "react";
import axios from "axios";
import { saveAs } from "file-saver";
import { withTranslation } from "react-i18next";
import sysJwt from "../../../utils/sysJwt";
import SysForm from "../../commonComponents/sysForm";
import { post } from "../../../utils/sysAxios";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { confirmAlert } from "react-confirm-alert";
import SysTable from "../../commonComponents/SysTable";
import { ExportSheet } from "react-xlsx-sheet";
import XLSX from "xlsx";

class Units extends Component {
  state = {
    data: {
      unitName: "",
      blockName: "",
      floorNum: "",
      ownerId: "",
      price: "",
      serviceFee: "",
      unitTypeId: "",
      internetType: "",
      internetUsername: "",
      internetUserId: "",
      serialNumber: "",
      subscriberNumber: "",
      activateServiceBill: "",
      elecMeterSerial: "",
      elecMeterPassword: "",
      elecMeterPhone: "",
    },

    allOwner: [],
    compoundsDropdown: [],
    unitTypesDropdown: [],
    unitTypesDropdownDisable: true,
    internetTypesDropdown: [
      { label: "Supercell", value: 1 },
      { label: "Earthlink", value: 2 },
    ],

    allTrueFalse: [
      { label: "True", value: true },
      { label: "False", value: false },
    ],

    contentHeader: "Units",
    addButtonLabel: "Add Unit",
    addButtonIcon: "fa fa-plus",

    dataUrl: "/api/data/GetUnits",
    singleItemUrl: "/api/data/GetUnit",
    addUrl: "/api/data/AddUnit",
    editUrl: "/api/data/EditUnit",
    deleteUrl: "/api/data/DeleteUnit",

    inEditMode: false,
    inModalMode: false,
    modalHeaderAdd: "Add Unit",
    modalSubmitButtonLabelAdd: "Add",
    modalSubmitButtonIconAdd: "fa fa-plus",
    modalHeaderEdit: "Edit Unit",
    modalSubmitButtonLabelEdit: "Edit",
    modalSubmitButtonIconEdit: "fa fa-edit",
    modalWidth: "50vw",

    editEntityId: 0,

    inBulkImportMode: false,
    bulkStage: "setup",       // "setup" | "preview" | "results"
    bulkCompoundId: "",
    bulkFile: null,
    bulkPreviewRows: [],
    bulkApplyResults: [],

    filterCompoundId: "",
    filterOwnerId: "",
    xlsxHeaders: [],

    tableData: [],
  };

  componentDidMount() {
    this.getData();
    this.getCompoundsDropdown();
    this.getAllOwner();
  }

  getAllElectricityTypes() {
    post(
      "/api/data/GetAllElectricityTypes",
      null,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      this.setState({
        allElectricityType: apiResponse.data.respData.data,
      });
    });
  }

  getAllOwner() {
    post("/api/data/getallowner", null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({
          allOwner: apiResponse.data.respData.data,
        });
      }
    );
  }

  getCompoundsDropdown() {
    post(
      "/api/data/GetAllCompoundsDropdown",
      null,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      this.setState({
        compoundsDropdown: apiResponse.data.respData.data,
      });
    });
  }

  getUnitTypesDropdown(compoundId) {
    post(
      "/api/data/GetUnitTypesDropdown",
      { CompoundId: compoundId },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      this.setState({
        unitTypesDropdown: apiResponse.data.respData.data,
      });
    });
  }

  onChangeCompoundsDropdown = (inputValue) => {
    this.getUnitTypesDropdown(inputValue);
    this.setState({ unitTypesDropdownDisable: false });
  };

  openBulkImport() {
    this.setState({
      inBulkImportMode: true,
      bulkStage: "setup",
      bulkCompoundId: "",
      bulkFile: null,
      bulkPreviewRows: [],
      bulkApplyResults: [],
    });
  }

  closeBulkImport() {
    this.setState({ inBulkImportMode: false });
    this.getData();
  }

  downloadUnitsExport() {
    this.props.updateIsLoading(true);
    axios
      .post(
        "/api/data/DownloadUnitsExport",
        { compoundId: this.state.bulkCompoundId || 0 },
        {
          headers: { Authorization: "Bearer " + sessionStorage.getItem("748784") },
          responseType: "blob",
        }
      )
      .then((res) => {
        saveAs(res.data, "UnitsExport.xlsx");
      })
      .finally(() => {
        this.props.updateIsLoading(false);
      });
  }

  doPreviewImport() {
    const { bulkFile } = this.state;
    if (!bulkFile) return;
    const formData = new FormData();
    formData.append("file", bulkFile, bulkFile.name);
    post("/api/data/PreviewBulkUnitImport", formData, this.props.updateIsLoading).then(
      (apiResponse) => {
        if (apiResponse && apiResponse.data.respCode === 0) {
          this.setState({
            bulkPreviewRows: apiResponse.data.respData.rows,
            bulkStage: "preview",
          });
        }
      }
    );
  }

  doApplyImport() {
    const validRows = this.state.bulkPreviewRows.filter((r) => r.status === "Valid");
    post(
      "/api/data/ApplyBulkUnitImport",
      { rows: validRows },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse && apiResponse.data.respCode === 0) {
        this.setState({
          bulkApplyResults: apiResponse.data.respData.results,
          bulkStage: "results",
        });
        this.getData();
      }
    });
  }

  updateForm = (inputId, inputValue) => {
    var data = this.state.data;
    data[inputId] = inputValue;
    this.setState({ data });
  };

  showForm() {
    this.setState({ inModalMode: true });
  }

  closeModal() {
    var data = this.state.data;

    Object.keys(data).forEach(function (key) {
      Array.isArray(data[key]) ? (data[key] = []) : (data[key] = "");
    });

    this.setState({
      inModalMode: false,
      inEditMode: false,
      data: data,
      editEntityId: 0,
      allClaims: [],
    });

    this.getData();
  }

  getData() {
    post(this.state.dataUrl, null, this.props.updateIsLoading).then(
      (apiResponse) => {
        const rows = apiResponse.data.respData.data;
        this.setState({ tableData: rows });
        this.buildExportHeaders(rows);
      }
    );
  }

  buildExportHeaders(rows) {
    if (!rows || rows.length === 0) return;
    let xlsxHeaders = [];
    for (var property in rows[0]) {
      if (rows[0].hasOwnProperty(property)) {
        xlsxHeaders.push({ title: property, dataIndex: property });
      }
    }
    this.setState({ xlsxHeaders: xlsxHeaders });
  }

  getFilteredData() {
    const { tableData, filterCompoundId, filterOwnerId } = this.state;
    return tableData.filter(
      (row) =>
        (!filterCompoundId || row.COMPOUND_ID === filterCompoundId) &&
        (!filterOwnerId || row.OWNER_ID === filterOwnerId)
    );
  }

  getEditFormData(row) {
    return post(
      this.state.singleItemUrl,
      { id: row.ID },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      this.getUnitTypesDropdown(apiResponse.data.respData.data[0].COMPOUND_ID);
      this.setState({ unitTypesDropdownDisable: false });
      var data = this.state.data;
      data["CompoundId"] = apiResponse.data.respData.data[0].COMPOUND_ID;
      data["unitName"] = apiResponse.data.respData.data[0].UNIT_NAME;
      data["blockName"] = apiResponse.data.respData.data[0].BLOCK_NAME;
      data["floorNum"] = apiResponse.data.respData.data[0].FLOOR_NUM;
      data["ownerId"] = apiResponse.data.respData.data[0].OWNERS_ID;
      data["price"] = apiResponse.data.respData.data[0].PRICE;
      data["serviceFee"] = apiResponse.data.respData.data[0].SERVICE_FEE;
      data["activateServiceBill"] =
        apiResponse.data.respData.data[0].CAL_SRVC_BILLS;
      data["unitTypeId"] = apiResponse.data.respData.data[0].UNIT_TYPE_ID;
      data["internetType"] = apiResponse.data.respData.data[0].INTERNET_TYPE;
      data["internetUsername"] =
        apiResponse.data.respData.data[0].INTERNET_USERNAME;
      data["internetUserId"] =
        apiResponse.data.respData.data[0].INTERNET_USER_ID;
      data["serialNumber"] = apiResponse.data.respData.data[0].SERIAL_NUMBER;
      data["elecMeterSerial"] =
        apiResponse.data.respData.data[0].ELEC_METER_SERIAL;
      data["elecMeterPassword"] =
        apiResponse.data.respData.data[0].ELEC_METER_PASSWORD;
      data["elecMeterPhone"] =
        apiResponse.data.respData.data[0].ELEC_METER_PHONE;

      this.setState({
        data: data,
        editEntityId: apiResponse.data.respData.data[0].ID,
      });
    });
  }

  handleDelete(row) {
    confirmAlert({
      title: this.props.t("dialog.deleteTitle"),
      message: this.props.t("dialog.deleteConfirm"),
      buttons: [
        { label: this.props.t("btn.yes"),
          onClick: () => {
            post(
              this.state.deleteUrl,
              { id: row.ID },
              this.props.updateIsLoading
            ).then((apiResponse) => {
              apiResponse.data.respCode === 0 ? this.getData() : null;
            });
          },
        },
        { label: this.props.t("btn.cancel"),
          onClick: () => null,
        },
      ],
    });
  }

  doSubmit() {
    const submitData = Object.assign({}, this.state.data);

    if (this.state.inEditMode) {
      submitData["id"] = this.state.editEntityId;
    }
    post(
      this.state.inEditMode ? this.state.editUrl : this.state.addUrl,
      submitData,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) {
        this.props.updateIsLoading(false);
        this.closeModal();
      }
    });
  }

  getColumns() {
    const { t } = this.props;
    return [
      {
        id: 1,
        label: t("col.id"),
        field: "ID",
        width: "85px",
      },
      {
        id: 14,
        label: t("col.compound"),
        field: "COMPOUND_NAME",
      },
      {
        id: 2,
        label: t("col.unitName"),
        field: "UNIT_NAME",
      },
      {
        id: 3,
        label: t("col.ownerName"),
        field: "OWNER_NAME",
      },
      {
        id: 4,
        label: t("col.block"),
        field: "BLOCK_NAME",
      },
      {
        id: 5,
        label: t("col.floorNumber"),
        field: "FLOOR_NUM",
      },
      {
        id: 6,
        label: t("col.electricitySerial"),
        field: "ELEC_METER_SERIAL",
      },
      {
        id: 7,
        label: t("col.electricityPhone"),
        field: "ELEC_METER_PHONE",
      },
      {
        id: 8,
        label: t("col.internetType"),
        field: "INTERNET_TYPE",
      },
      {
        id: 9,
        label: t("col.internetUserId"),
        field: "INTERNET_USER_ID",
      },
      {
        id: 10,
        label: t("col.internetUsername"),
        field: "INTERNET_USERNAME",
      },
      {
        id: 11,
        label: t("col.insertDate"),
        field: "INSERT_DATE",
      },
      {
        id: 12,
        label: t("col.lastUpdate"),
        field: "LAST_UPDATE",
      },
      {
        id: 13,
        label: t("col.actions"),
        field: "SYS_ACTINOS",
        width: "120px",
        maxResizeWidth: "120px",
        resizable: false,
        pinned: true,
        cellRenderer: ({ data }) => {
          return (
            <div id="outer">
              {sysJwt.isAuthorized(["CB1C"]) && (
                <div className="inner" title="Edit">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => {
                      this.getEditFormData(data).then(() => {
                        this.setState({
                          inEditMode: true,
                        });
                        this.showForm();
                      });
                    }}
                  >
                    <i className="fa fa-edit" />
                  </button>
                </div>
              )}
              {sysJwt.isAuthorized(["CB1D"]) && (
                <div className="inner" title="Delete">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => this.handleDelete(data)}
                  >
                    <i className="fa fa-trash" />
                  </button>
                </div>
              )}
              <div className="inner" title="Show Service Bills">
                <button
                  className="dropdown-item btn-popup-menu"
                  disabled={this.props.isLoading}
                  onClick={() =>
                    window.location.replace(
                      "/dashboard/unitservicebills?unitId=" +
                        data.ID +
                        "&unitName=" +
                        data.UNIT_NAME
                    )
                  }
                >
                  <i className="fa fa-file-text" />
                </button>
              </div>
              {data.ELECTRICITY_TYPE === "Voucher" ? (
                <div className="inner" title="Show Electricty Vouchers">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() =>
                      window.location.replace(
                        "/dashboard/unitelectrictyvouchers?unitId=" +
                          data.ID +
                          "&unitName=" +
                          data.UNIT_NAME
                      )
                    }
                  >
                    <i className="fa fa-plug" />
                  </button>
                </div>
              ) : (
                ""
              )}
              <div className="inner" title="Unit Contract">
                <button
                  className="dropdown-item btn-popup-menu"
                  disabled={this.props.isLoading}
                  onClick={() =>
                    window.location.replace(
                      "/dashboard/unitcontracts?unitId=" +
                        data.ID +
                        "&unitName=" +
                        data.UNIT_NAME
                    )
                  }
                >
                  <i className="fa fa-book" />
                </button>
              </div>
            </div>
          );
        },
      },
    ];
  }

  render() {
    const { t } = this.props;
    return (
      <div className="bms-content-component fade-in">
        <div className="row">
          <div className="col">
            <h4>{t("pages.units")}</h4>
          </div>
          <div className="col flex-container-left">
            {sysJwt.isAuthorized(["CB1B"]) && (
              <Button
                label={t("pages.addUnit")}
                icon={this.state.addButtonIcon}
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => {
                  this.setState({ inEditMode: false });
                  this.showForm();
                }}
              />
            )}
            {sysJwt.isAuthorized(["CB1B"]) && (
              <Button
                label={t("btn.bulkImport")}
                icon="fa fa-upload"
                className="p-button-rounded p-button-secondary"
                style={{ marginLeft: "8px" }}
                disabled={this.props.isLoading}
                onClick={() => this.openBulkImport()}
              />
            )}
          </div>
        </div>
        <hr />
        {/* Filter bar */}
        <div className="page-filter-bar">
          <span className="filter-label">{t("filter.compound")}:</span>
          <Dropdown
            value={this.state.filterCompoundId}
            options={this.state.compoundsDropdown}
            showClear
            filter
            onChange={(e) => this.setState({ filterCompoundId: e.value })}
            placeholder={t("filter.allCompounds")}
          />

          <span className="filter-label">{t("filter.owner")}:</span>
          <Dropdown
            value={this.state.filterOwnerId}
            options={this.state.allOwner}
            showClear
            filter
            onChange={(e) => this.setState({ filterOwnerId: e.value })}
            placeholder={t("filter.all")}
          />

          <Button
            label={t("filter.clear")}
            icon="fa fa-eraser"
            className="p-button-rounded p-button-secondary"
            disabled={this.props.isLoading}
            onClick={() =>
              this.setState({ filterCompoundId: "", filterOwnerId: "" })
            }
          />

          {this.getFilteredData().length > 0 && (
            <ExportSheet
              header={this.state.xlsxHeaders}
              dataSource={this.getFilteredData()}
              fileName="UnitsExport"
              isRequiredNameDate={false}
              xlsx={XLSX}
            >
              <Button
                className="p-button-rounded p-button-success"
                label={t("btn.exportExcel")}
                icon="fa fa-file-excel-o"
              />
            </ExportSheet>
          )}
        </div>
        <Dialog
          visible={this.state.inModalMode}
          style={{ width: this.state.modalWidth }}
          onHide={(e) => this.closeModal()}
          dismissableMask={true}
          closable={false}
          header={
            <h5 className="modal-header">
              {this.state.inEditMode ? t("dialog.editTitle") : t("dialog.addTitle")}
            </h5>
          }
          footer={
            <div>
              <Button
                label={this.state.inEditMode ? t("btn.edit") : t("btn.add")}
                icon={
                  this.state.inEditMode
                    ? this.state.modalSubmitButtonIconEdit
                    : this.state.modalSubmitButtonIconAdd
                }
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.doSubmit()}
              />
              <Button
                label={t("btn.cancel")}
                icon="fa fa-close"
                className="p-button-rounded p-button-danger"
                onClick={() => this.closeModal()}
              />
            </div>
          }
        >
          <SysForm
            isLoading={this.props.isLoading}
            inEditMode={this.state.inEditMode}
            data={this.state.data}
            updateForm={this.updateForm}
            inputs={[
              {
                type: "text",
                id: "unitName",
                label: t("col.unitName"),
                disabled: false,
              },
              {
                type: "dropdown",
                id: "CompoundId",
                label: t("col.compound"),
                options: this.state.compoundsDropdown,
                disabled: false,
                customOnChangeHandler: this.onChangeCompoundsDropdown,
              },
              {
                type: "dropdown",
                id: "unitTypeId",
                label: t("col.unitType"),
                options: this.state.unitTypesDropdown,
                disabled: this.state.unitTypesDropdownDisable,
              },
              {
                type: "text",
                id: "blockName",
                label: t("col.block"),
                disabled: false,
              },
              {
                type: "text",
                id: "floorNum",
                label: t("col.floorNumber"),
                disabled: false,
              },
              {
                type: "dropdown",
                id: "ownerId",
                label: t("col.owner"),
                options: this.state.allOwner,
                disabled: false,
              },
              {
                type: "text",
                id: "price",
                label: t("col.price"),
                disabled: false,
              },
              {
                type: "dropdown",
                id: "activateServiceBill",
                label: t("col.activateServiceBills"),
                options: this.state.allTrueFalse,
                disabled: false,
              },
              {
                type: "text",
                id: "serviceFee",
                label: t("col.serviceFee"),
                disabled: false,
                tooltip:
                  "An amount is entered in case that the calculation of the amount is different from the service fees in the subcategory",
              },
              {
                type: "dropdown",
                id: "internetType",
                label: t("col.internetType"),
                options: this.state.internetTypesDropdown,
                disabled: false,
              },
              {
                type: "text",
                id: "internetUsername",
                label: t("col.internetUsername"),
                disabled: false,
              },
              {
                type: "text",
                id: "internetUserId",
                label: t("col.internetUserId"),
                disabled: false,
              },
              {
                type: "text",
                id: "elecMeterSerial",
                label: t("col.electricityMeterSerial"),
                disabled: false,
              },
              {
                type: "text",
                id: "elecMeterPassword",
                label: t("col.electricityPassword"),
                disabled: false,
              },
              {
                type: "text",
                id: "elecMeterPhone",
                label: t("col.electricityPhone"),
                disabled: false,
              },
            ]}
          />
        </Dialog>
        {/* ── Bulk Import Dialog ── */}
        <Dialog
          visible={this.state.inBulkImportMode}
          style={{ width: this.state.bulkStage === "preview" ? "80vw" : "55vw" }}
          onHide={() => this.closeBulkImport()}
          dismissableMask={false}
          closable={false}
          header={<h5 className="modal-header">{t("btn.bulkImport")}</h5>}
          footer={
            <div>
              {this.state.bulkStage === "setup" && (
                <Button
                  label={t("bulk.preview")}
                  icon="fa fa-search"
                  className="p-button-rounded p-button-secondary"
                  disabled={!this.state.bulkFile || this.props.isLoading}
                  onClick={() => this.doPreviewImport()}
                />
              )}
              {this.state.bulkStage === "preview" && (
                <>
                  <Button
                    label={t("bulk.confirmApply")}
                    icon="fa fa-check"
                    className="p-button-rounded p-button-success"
                    disabled={
                      this.state.bulkPreviewRows.filter((r) => r.status === "Valid").length === 0 ||
                      this.props.isLoading
                    }
                    onClick={() => this.doApplyImport()}
                  />
                  <Button
                    label={t("bulk.back")}
                    icon="fa fa-arrow-left"
                    className="p-button-rounded p-button-secondary"
                    style={{ marginLeft: "8px" }}
                    disabled={this.props.isLoading}
                    onClick={() => this.setState({ bulkStage: "setup" })}
                  />
                </>
              )}
              <Button
                label={t("btn.close")}
                icon="fa fa-close"
                className="p-button-rounded p-button-danger"
                style={{ marginLeft: "8px" }}
                onClick={() => this.closeBulkImport()}
              />
            </div>
          }
        >
          {/* ── Stage 1: Setup ── */}
          {this.state.bulkStage === "setup" && (
            <div>
              <div style={{ marginBottom: "14px" }}>
                <label style={{ fontWeight: "bold", display: "block", marginBottom: "6px", color: "black" }}>
                  {t("col.compound")}:
                </label>
                <Dropdown
                  value={this.state.bulkCompoundId}
                  options={this.state.compoundsDropdown}
                  showClear
                  filter
                  onChange={(e) => this.setState({ bulkCompoundId: e.value || "" })}
                  placeholder={t("bulk.allCompounds")}
                  style={{ width: "100%" }}
                />
              </div>
              <div style={{ marginBottom: "16px" }}>
                <Button
                  label={t("bulk.downloadData")}
                  icon="fa fa-download"
                  className="p-button-rounded p-button-info"
                  disabled={this.props.isLoading}
                  onClick={() => this.downloadUnitsExport()}
                />
                <span style={{ marginLeft: "10px", color: "#666", fontSize: "12px" }}>
                  {t("bulk.downloadHint")}
                </span>
              </div>
              <hr />
              <div style={{ marginBottom: "10px" }}>
                <label style={{ fontWeight: "bold", display: "block", marginBottom: "6px", color: "black" }}>
                  {t("btn.excelFile")}:
                </label>
                <input
                  type="file"
                  accept=".xlsx,.xls"
                  style={{ display: "block" }}
                  onChange={(e) => this.setState({ bulkFile: e.target.files[0] || null })}
                />
              </div>
              <p style={{ marginTop: "10px", color: "#666", fontSize: "12px" }}>
                {t("bulk.uploadHint")}
              </p>
            </div>
          )}

          {/* ── Stage 2: Preview ── */}
          {this.state.bulkStage === "preview" && (
            <div>
              <div style={{ marginBottom: "12px", display: "flex", gap: "16px", flexWrap: "wrap" }}>
                <span style={{ display: "inline-flex", alignItems: "center", gap: "6px", background: "#d4edda", color: "#155724", padding: "4px 10px", borderRadius: "20px", fontWeight: "600", fontSize: "13px" }}>
                  <b>{this.state.bulkPreviewRows.filter((r) => r.status === "Valid" && r.action === "Add").length}</b>
                  {t("bulk.toAdd")}
                </span>
                <span style={{ display: "inline-flex", alignItems: "center", gap: "6px", background: "#fff3cd", color: "#856404", padding: "4px 10px", borderRadius: "20px", fontWeight: "600", fontSize: "13px" }}>
                  <b>{this.state.bulkPreviewRows.filter((r) => r.status === "Valid" && r.action === "Update").length}</b>
                  {t("bulk.toUpdate")}
                </span>
                <span style={{ display: "inline-flex", alignItems: "center", gap: "6px", background: "#f8d7da", color: "#721c24", padding: "4px 10px", borderRadius: "20px", fontWeight: "600", fontSize: "13px" }}>
                  <b>{this.state.bulkPreviewRows.filter((r) => r.status === "Error").length}</b>
                  {t("bulk.errors")}
                </span>
              </div>
              <div style={{ maxHeight: "55vh", overflowY: "auto" }}>
                <table className="table table-sm table-bordered" style={{ fontSize: "13px" }}>
                  <thead className="thead-light" style={{ position: "sticky", top: 0 }}>
                    <tr>
                      <th style={{ width: "55px" }}>{t("btn.row")}</th>
                      <th style={{ width: "80px" }}>{t("bulk.action")}</th>
                      <th>{t("col.unitName")}</th>
                      <th>{t("col.block")}</th>
                      <th>{t("col.ownerName")}</th>
                      <th style={{ width: "80px" }}>{t("col.status")}</th>
                      <th>{t("col.details")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.bulkPreviewRows.map((r, i) => (
                      <tr
                        key={i}
                        className={
                          r.status === "Error"
                            ? "table-danger"
                            : r.action === "Add"
                            ? "table-success"
                            : "table-warning"
                        }
                      >
                        <td>{r.row}</td>
                        <td>{r.action}</td>
                        <td>{r.unitName}</td>
                        <td>{r.blockName}</td>
                        <td>{r.ownerName}</td>
                        <td>{r.status}</td>
                        <td>{r.message}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* ── Stage 3: Results ── */}
          {this.state.bulkStage === "results" && (
            <div>
              <p style={{ marginBottom: "8px", fontWeight: "bold", color: "black" }}>
                {this.state.bulkApplyResults.filter((r) => r.status === "Success").length}{" "}
                {t("btn.of")}{" "}
                {this.state.bulkApplyResults.length}{" "}
                {t("btn.rowsImported")}
              </p>
              <table className="table table-sm table-bordered" style={{ fontSize: "13px" }}>
                <thead className="thead-light">
                  <tr>
                    <th style={{ width: "55px" }}>{t("btn.row")}</th>
                    <th style={{ width: "80px" }}>{t("bulk.action")}</th>
                    <th>{t("col.unitName")}</th>
                    <th style={{ width: "80px" }}>{t("col.status")}</th>
                    <th>{t("col.details")}</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.bulkApplyResults.map((r, i) => (
                    <tr key={i} className={r.status === "Success" ? "table-success" : "table-danger"}>
                      <td>{r.row}</td>
                      <td>{r.action}</td>
                      <td>{r.unitName}</td>
                      <td>{r.status}</td>
                      <td>{r.message}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Dialog>

        <SysTable
          columns={this.getColumns()}
          rows={this.getFilteredData()}
          pageSizes={[10, 15, 20, 25, 30]}
        />
      </div>
    );
  }
}

export default withTranslation()(Units);
